export type DarkModePreference = 'system' | 'light' | 'dark';

export const DARK_MODE_STORAGE_KEY = 'darkMode';

/**
 * Everyone who has never touched the toggle gets light, which is what the portals looked like
 * before dark mode existed. Defaulting to 'system' instead would have flipped every user whose OS
 * is set to dark into a theme they never asked for, on an app they already knew - so 'system' stays
 * available in the toggle, but only as a deliberate choice.
 *
 * storedRaw is passed through as-is from localStorage.getItem(); anything other than exactly
 * 'dark'/'light'/'system' (missing key or corrupted value) falls back to light.
 */
export function resolveStoredPreference(
  storedRaw: string | null,
  fallback: DarkModePreference = 'light',
): DarkModePreference {
  return storedRaw === 'dark' || storedRaw === 'light' || storedRaw === 'system'
    ? storedRaw
    : fallback;
}

/** Whether dark styling should actually be applied for a given preference. */
export function resolveIsDark(preference: DarkModePreference, prefersDark: boolean): boolean {
  return preference === 'system' ? prefersDark : preference === 'dark';
}
